import { Row, Col, Table } from "react-bootstrap";
import React, { useState, useImperativeHandle, forwardRef, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { validateForm } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { isAllowDashedPercentageSpecialCharacters, isAllowDashedSpecialCharacters, isAlphanumericWithPlusAmpersandEqualsPlusMinus, isAlphanumericWithPlusAmpersandEqualsLessThanMinus, isAlphanumericWithPlusAmpersandEqualsPercentMinus } from "../../functions/validations";
import { WPSHeader } from "./WPSObjects/WPSHeader";
import { WPS_TYPES } from "../utility/common/constants/CommonConstants";
import {
  handleGeneralSubmit, handleGeneralSubmitTemp, initializeErrorState, handleArrayChange,
  handleDetailChange as handledetailObjchange, handleHeaderchange
} from "./WPSObjects/WPSCommonUtils";
import {
  WPS_Groove_Detail,
  Weld_Progression,
  Tungsten_size,
  Layer_No,
  Position_of_groove,
  Tungsten_type,
  WPS_Overlay_Detail,
  WPSPage2,
} from "./WPSObjects/WPSGroove_entity";
import { Arc_Transfer, Current_Polarity, FM_Product_Form, Single_Pass } from "../utility/common/TransactionComponents/TransactionEntity";
import {
  WPSProcessGridInput,
  WPSProcessGridInput2,
  WPS_Process_Grid_Input_3,
  WPS_Process_Grid_Input_3Filermetal,
  WPSProcessGridSelect,
  WPS_Process_Grid_Select_3,
  WPS_Process_Grid_Select_master_data_with_popup,
  WPS_Process_Grid_Input_2_Amperes
} from "./WPSObjects/WPS_Process_Grid";
import { handleHeaderDetailAdd, handleStatusChange } from "./WPSObjects/WPSDataService";
import { getActiveItemForProject } from "../../Services/item-services";
import { DotLoader } from "react-spinners";
import { maxLength_WPS } from "./WPSObjects/maxlength_WPS";
import { SingleInput } from "../utility/forms/inputs/InputsTransaction";
import { RenderIf } from "../../functions/welding-functions";
import SingleValuePopUp from "../utility/ui/modals/SingleValuePopUp";

const WeldingProcedure = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      logObj,
      setKey,
      tabno,
      setIsEditedPage2,
      isReadonly,
      action,
      setAction
    },
    ref
  ) => {

    const [ItemActive, setItemActive] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const [WPStype] = useState(location.state?.WPStype);
    const [IsEdited, setIsEdited] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [popUp, setPopUp] = useState({
      name: "",
      type: "",
      key: "",
      value: "",
      rowIndex: -1,
      colIndex: -1,
    });

    const isoverlay = WPStype !== "Groove";

    const showPopUp = (name, type, key, value, rowIndex, colIndex) => {
      setPopUp({ name, type, key, value, rowIndex, colIndex });
      setShowForm(true);
    };

    const setPopUpData = (data) => {
      if (data.name === "ItemActive") {
        let onChangeVal = [...detailObj];
        onChangeVal[popUp.rowIndex]["WPSD_WP_WeldConsumable"][popUp.colIndex] = data.result.wld_itemcode;
        // Store description in welddesc field (same as grid component)
        onChangeVal[popUp.rowIndex]["welddesc"][popUp.colIndex] = data.result.wld_description || "";
        onChangeVal[popUp.rowIndex]["weldweight"][popUp.colIndex] = data.result.wld_weight || "";
        setdetailObj(onChangeVal);
        setError((prevState) => ({
          ...prevState,
          WPSD_WP_WeldConsumable: { status: false, message: "" },
        }));
      }
    };


    const fetchitem = async () => {
      const result = await getActiveItemForProject(headerObj.WPSH_Project_No);
      const filteredResult = result.filter(item => item.wld_itemcode && item.wld_itemcode.trim() !== "");

      setItemActive(filteredResult);
    };
    useEffect(() => {
      fetchitem();
    }, [headerObj.WPSH_Project_No]);

    useImperativeHandle(ref, () => ({
      funcOnNext2: async () => {
        return handleSubmit();
      },
      funcOnNextTemp2: async () => {
        return handleSubmitTemp();
      },
    }));




    const handleSubmitTemp = () => handleGeneralSubmitTemp(
      IsEdited, validateTemp, handleAdd, setLoading, setIsEdited, setIsEditedPage2, headerObj.WPSH_Status
    );

    const handleSubmit = () => handleGeneralSubmit(
      validate, handleAdd, setLoading, setIsEdited, setIsEditedPage2, headerObj.WPSH_Status
    );

    const wps_detail = useMemo(() => {
      const filtered = detailObj.filter((item) => item.WPSD_Process !== "");
      console.log("WPSDetail", filtered)
      return filtered.length > 0 ? filtered : detailObj;
    }, [detailObj]);


    const [error, setError] = useState(initializeErrorState('page2'));

    const validate = async () => {
      const errorConfig = WPStype === WPS_TYPES.GROOVE ? WPS_Groove_Detail : WPS_Overlay_Detail;
      const detaildata = detailObj.filter((item) => item.WPSD_Process !== "");
      const validationResult = validateForm({
        headerObj,
        detailObj: detaildata,
        requiredFields: WPSPage2,
        detailConfig: errorConfig,
        currentErrors: error
      });

      setError(validationResult.errors);
      return validationResult.isError;
    };



    // Consolidated change handler
    const handleArrchange = (row, col, key, e, options = {}) => {
      handleArrayChange(
        { row, col },
        key,
        e,
        { detailObj, setdetailObj },
        { setError },
        { action, setIsEdited, setIsEditedPage2 },
        options
      )
    }


    const validateTemp = async () => {
      let isError = false;
      return { isError };
    };


    //changes for header change
    const handleChangeHeader = (e) => handleHeaderchange(
      e,
      { setheaderObj, setError },
      { action, setIsEdited, setEditedPage1: null, setEditedPage2: setIsEditedPage2, setEditedPage3: null },
      error
    )

    // single fields detail change handler
    const handleDetailChange = (e, i, clearError = false) =>
      handledetailObjchange(
        e,
        i,
        { detailObj, setdetailObj },
        { setError },
        { action, setIsEdited, setIsEditedPage2 },
        { clearError }
      )



    // Use common WPS data service for add operations
    const handleAdd = async (savetype) => {
      handleStatusChange(headerObj, location, action);
      return handleHeaderDetailAdd(headerObj, detailObj, location, savetype);
    };


    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <WPSHeader headerObj={headerObj}></WPSHeader>
        <Row className="mb-4" style={{ padding: "20px 30px" }}>
          <span className="WPS-blue-text">Welding Procedure</span>
          <div className="scrollwps">
            <Col>
              <Table
                bordered
                responsive="sm"
                className="text-center same-col-widths align-middle"
              >
                {isoverlay ? (
                  <thead>
                    <tr className="align-middle">
                      <th className="text-start thead-color">
                        Weld Layer
                      </th>
                      {wps_detail.map((item, id) => {
                        return (
                          <th
                            className={
                              item.WPSD_Process === "" && item.WPSD_Type === ""
                                ? "empty-process"
                                : ""
                            }
                          >
                            {item.WPSH_WeldLayer}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                ) : (
                  ""
                )}
                <thead>
                  <tr className="align-middle">
                    <th className="text-start thead-color" style={{ width: "310px" }}>
                      Process - Type
                    </th>
                    {wps_detail.map((item, id) => {

                      return (
                        <th

                          className={
                            item.WPSD_Process === "" && item.WPSD_Type === ""
                              ? "empty-process"
                              : ""
                          }
                        >
                          {item.WPSD_Process}-{item.WPSD_Type}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    ColumnHeader="Minimum Preheat"
                    Columndimension="°C"
                    status={error.WPSD_WP_MinimumPreheatTemp.status}
                    message={error.WPSD_WP_MinimumPreheatTemp.message}
                    type="text"
                    maxLength={maxLength_WPS.WPSD_WP_MinimumPreheatTemp}
                    name="WPSD_WP_MinimumPreheatTemp"
                    disabled={isReadonly}
                    setError={setError}
                    handleChange={handleDetailChange}
                  ></WPSProcessGridInput>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    disabled={isReadonly}
                    ColumnHeader=" Maximum Interpass Temp"
                    Columndimension="°C"
                    maxLength={maxLength_WPS.WPSD_WP_MaximumInterpassTemp}
                    status={error.WPSD_WP_MaximumInterpassTemp.status}
                    message={error.WPSD_WP_MaximumInterpassTemp.message}
                    type="text"
                    name="WPSD_WP_MaximumInterpassTemp"
                    setError={setError}
                    handleChange={handleDetailChange}
                  ></WPSProcessGridInput>
                  <WPSProcessGridSelect
                    wps_detail={wps_detail}
                    disabled={isReadonly}
                    ColumnHeader={
                      <span className="greenfont" style={{ fontWeight: "700" }}>
                        Filler Metal Product Form
                      </span>
                    }
                    status={error.WPSD_WP_FillerMetalProductForm.status}
                    message={error.WPSD_WP_FillerMetalProductForm.message}
                    name="WPSD_WP_FillerMetalProductForm"
                    array={FM_Product_Form}
                    handleChange={handleDetailChange}
                  ></WPSProcessGridSelect>

                  <WPS_Process_Grid_Input_3Filermetal
                    wps_detail={wps_detail}
                    ColumnHeader="Filler Metal Size Ø"
                    Columndimension="mm"
                    status={error.WPSD_WP_FillerMetalSIze.status}
                    message={error.WPSD_WP_FillerMetalSIze.message}


                    maxLength={maxLength_WPS.WPSD_WP_FillerMetalSIze}

                    type="text"
                    name="WPSD_WP_FillerMetalSIze"
                    metal="WPSD_WP_FillerMetalSIze"
                    disabled={isReadonly}
                    setError={setError}
                    handleChangeFillermetal={handleArrchange}

                  ></WPS_Process_Grid_Input_3Filermetal>

                  <WPS_Process_Grid_Select_master_data_with_popup
                    data={ItemActive}
                    disabled={isReadonly}
                    valueField="wld_itemcode"
                    labelField="wld_itemcode"
                    name="WPSD_WP_WeldConsumable"
                    setdetailObj={setdetailObj}
                    detailObj={detailObj}
                    setError={setError}
                    wps_detail={wps_detail}
                    ColumnHeader="Welding Consumable Item Code"
                    Columndimension="mm"
                    status={error.WPSD_WP_WeldConsumable.status}
                    message={error.WPSD_WP_WeldConsumable.message}
                    setIsEdited={setIsEdited}
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                    showPopUp={showPopUp}
                    headerObj={headerObj}
                  ></WPS_Process_Grid_Select_master_data_with_popup>
                  <WPS_Process_Grid_Input_3
                    wps_detail={wps_detail}
                    disabled={isReadonly}
                    readOnly={isReadonly}
                    ColumnHeader="Batch No"
                    status={error.WPSD_WP_BatchNumber.status}
                    message={error.WPSD_WP_BatchNumber.message}

                    maxLength={maxLength_WPS.WPSD_WP_BatchNumber}

                    type="text"
                    name="WPSD_WP_BatchNumber"
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                    handleChange={handleArrchange}
                    setError={setError}

                  ></WPS_Process_Grid_Input_3>

                  {isoverlay ? (
                    ""
                  ) : (
                    <WPS_Process_Grid_Select_3
                      wps_detail={wps_detail}
                      disabled={isReadonly}
                      ColumnHeader="Layer No."
                      status={error.WPSD_WP_LayerNumber.status}
                      message={error.WPSD_WP_LayerNumber.message}

                      array={Layer_No}

                      type="text"
                      name="WPSD_WP_LayerNumber"
                      handleChange={handleArrchange}
                      fieldfiller="WPSD_WP_FillerMetalSIze"
                    ></WPS_Process_Grid_Select_3>
                  )}

                  {isoverlay ? (
                    <WPS_Process_Grid_Select_3
                      wps_detail={wps_detail}
                      disabled={isReadonly}
                      ColumnHeader="Position Of Overlay"
                      Columndimension=""
                      status={error.WPSD_WP_PositionOfOverlay.status}
                      message={error.WPSD_WP_PositionOfOverlay.message}


                      array={Position_of_groove}
                      type="text"
                      name="WPSD_WP_PositionOfOverlay"
                      handleChange={handleArrchange}
                      fieldfiller="WPSD_WP_FillerMetalSIze"
                    ></WPS_Process_Grid_Select_3>
                  ) : (
                    <WPS_Process_Grid_Select_3
                      wps_detail={wps_detail}
                      disabled={isReadonly}
                      ColumnHeader="Position Of Groove"
                      status={error.WPSD_WP_PositionOfGroove.status}
                      message={error.WPSD_WP_PositionOfGroove.message}


                      array={Position_of_groove}
                      type="text"
                      name="WPSD_WP_PositionOfGroove"
                      handleChange={handleArrchange}
                      fieldfiller="WPSD_WP_FillerMetalSIze"
                    ></WPS_Process_Grid_Select_3>
                  )}
                  {isoverlay ? (
                    ""
                  ) : (

                    <WPS_Process_Grid_Input_3
                      wps_detail={wps_detail}
                      readOnly={isReadonly}
                      disabled={isReadonly}
                      ColumnHeader="Position Of Fillet"
                      Columndimension=""
                      status={error.WPSD_WP_PositionOfFillet.status}
                      message={error.WPSD_WP_PositionOfFillet.message}

                      maxLength={maxLength_WPS.WPSD_WP_FillerMetalSIze}

                      type="text"
                      name="WPSD_WP_PositionOfFillet"
                      fieldfiller="WPSD_WP_FillerMetalSIze"
                      handleChange={handleArrchange}
                      setError={setError}
                    ></WPS_Process_Grid_Input_3>
                  )}

                  <WPS_Process_Grid_Select_3
                    wps_detail={wps_detail}
                    disabled={isReadonly}
                    ColumnHeader=" Weld Progression"
                    status={error.WPSD_WP_WeldProgression.status}
                    message={error.WPSD_WP_WeldProgression.message}


                    array={Weld_Progression}
                    type="text"
                    name="WPSD_WP_WeldProgression"
                    handleChange={handleArrchange}
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                  ></WPS_Process_Grid_Select_3>

                  <WPS_Process_Grid_Select_3
                    wps_detail={wps_detail}
                    disabled={isReadonly}
                    ColumnHeader={
                      <span className="greenfont" style={{ fontWeight: "700" }}>
                        Current Polarity
                      </span>
                    }

                    status={error.WPSD_WP_CurrentPolarity.status}
                    message={error.WPSD_WP_CurrentPolarity.message}


                    type="text"
                    array={Current_Polarity}
                    name="WPSD_WP_CurrentPolarity"
                    handleChange={handleArrchange}
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                  ></WPS_Process_Grid_Select_3>
                  {isoverlay ? (
                    <WPS_Process_Grid_Input_2_Amperes
                      disabled={isReadonly}
                      readOnly={isReadonly}
                      wps_detail={wps_detail}
                      ColumnHeader="Amperes"
                      Columndimension="Amps"
                      maxLength={maxLength_WPS.WPSD_WP_Amperes1}
                      status={error.WPSD_WP_Amperes.status}
                      message={error.WPSD_WP_Amperes.message}
                      status1={error.WPSD_WP_Amperes1.status}
                      message1={error.WPSD_WP_Amperes1.message}
                      type="text"
                      name="WPSD_WP_Amperes"
                      name1="WPSD_WP_Amperes1"
                      handleChange={handleArrchange}
                      fieldfiller="WPSD_WP_FillerMetalSIze"
                      setError={setError}
                    ></WPS_Process_Grid_Input_2_Amperes>
                  ) : (
                    <WPS_Process_Grid_Input_3
                      wps_detail={wps_detail}
                      disabled={isReadonly}
                      ColumnHeader="Amperes"
                      Columndimension="Amps"
                      maxLength={maxLength_WPS.WPSD_WP_Amperes}
                      status={error.WPSD_WP_Amperes.status}
                      message={error.WPSD_WP_Amperes.message}

                      type="text"
                      name="WPSD_WP_Amperes"
                      handleChange={handleArrchange}
                      fieldfiller="WPSD_WP_FillerMetalSIze"
                      validatorFn={isAllowDashedSpecialCharacters}
                      setError={setError}
                    ></WPS_Process_Grid_Input_3>
                  )}


                  {isoverlay ? (
                    ""
                  ) : (
                    <WPSProcessGridInput
                      wps_detail={wps_detail}
                      readOnly={isReadonly}
                      disabled={isReadonly}
                      ColumnHeader="Pulsing Current"
                      maxLength={maxLength_WPS.WPSD_WP_Pulsing_current}
                      Columndimension="Amps"
                      status={error.WPSD_WP_Pulsing_current.status}
                      message={error.WPSD_WP_Pulsing_current.message}
                      type="text"
                      name="WPSD_WP_Pulsing_current"
                      validatorFn={isAllowDashedSpecialCharacters}
                      setError={setError}
                      handleChange={handleDetailChange}
                    ></WPSProcessGridInput>
                  )}

                  <WPS_Process_Grid_Input_3
                    wps_detail={wps_detail}
                    disabled={isReadonly}
                    readOnly={isReadonly}
                    ColumnHeader="Voltage"
                    Columndimension="Volts"
                    maxLength={maxLength_WPS.WPSD_WP_Volts}
                    status={error.WPSD_WP_Volts.status}
                    message={error.WPSD_WP_Volts.message}

                    type="text"
                    name="WPSD_WP_Volts"
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                    handleChange={handleArrchange}
                    validatorFn={isAllowDashedSpecialCharacters}
                    setError={setError}
                  ></WPS_Process_Grid_Input_3>

                  <WPS_Process_Grid_Input_3
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Travel Speed"
                    Columndimension="mm/min"
                    status={error.WPSD_WP_TravelSpeed.status}
                    message={error.WPSD_WP_TravelSpeed.message}

                    maxLength={maxLength_WPS.WPSD_WP_TravelSpeed}

                    type="text"
                    name="WPSD_WP_TravelSpeed"
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                    handleChange={handleArrchange}
                    validatorFn={isAllowDashedSpecialCharacters}
                    setError={setError}
                  ></WPS_Process_Grid_Input_3>


                  <WPS_Process_Grid_Input_3
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Minimum bead Length (SMAW)"
                    Columndimension="mm"
                    status={error.WPSD_WP_MinimumBeadLength.status}
                    message={error.WPSD_WP_MinimumBeadLength.message}

                    maxLength={maxLength_WPS.WPSD_WP_FillerMetalSIze}

                    type="text"
                    name="WPSD_WP_MinimumBeadLength"
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                    handleChange={handleArrchange}
                    setError={setError}
                  ></WPS_Process_Grid_Input_3>

                  <WPS_Process_Grid_Input_3
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Maximum Heat Input"
                    maxLength={maxLength_WPS.WPSD_WP_FillerMetalSIze}
                    Columndimension="KJ/mm or KJ/mm2"
                    status={error.WPSD_WP_MaximumHeatInput.status}
                    message={error.WPSD_WP_MaximumHeatInput.message}

                    type="text"
                    name="WPSD_WP_MaximumHeatInput"
                    fieldfiller="WPSD_WP_FillerMetalSIze"
                    handleChange={handleArrchange}
                    validatorFn={isAlphanumericWithPlusAmpersandEqualsPlusMinus}
                    setError={setError}
                  ></WPS_Process_Grid_Input_3>

                  <WPSProcessGridSelect
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Tungsten Size"
                    Columndimension="mm"
                    status={error.WPSD_WP_TungstenSIze.status}
                    message={error.WPSD_WP_TungstenSIze.message}
                    name="WPSD_WP_TungstenSIze"
                    handleChange={handleDetailChange}
                    option
                    array={Tungsten_size}
                  ></WPSProcessGridSelect>
                  <WPSProcessGridSelect
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Tungsten Type"
                    Columndimension=""
                    status={error.WPSD_WP_TungstenType.status}
                    message={error.WPSD_WP_TungstenType.message}
                    name="WPSD_WP_TungstenType"
                    handleChange={handleDetailChange}
                    option
                    array={Tungsten_type}
                  ></WPSProcessGridSelect>
                  <WPSProcessGridInput2
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    mainheading="Shielding"
                    maxLength={maxLength_WPS.WPSD_WP_ShieldingGasType}
                    ColumnHeader="Gas Type - % comp"
                    ColumnHeader1="Flow Rate"
                    Columndimension="I/min"
                    status={
                      error.WPSD_WP_ShieldingGasType.status ||
                      error.WPSD_WP_ShieldingFlowRate.status
                    }
                    message={
                      error.WPSD_WP_ShieldingGasType.message ||
                      error.WPSD_WP_ShieldingFlowRate.message
                    }
                    type="text"
                    name="WPSD_WP_ShieldingGasType"
                    name1="WPSD_WP_ShieldingFlowRate"
                    validatorFn={isAllowDashedPercentageSpecialCharacters}
                    validatorFn1={isAllowDashedSpecialCharacters}
                    handleChange={handleDetailChange}
                    setError={setError}
                    customWidth={"275px"}
                  ></WPSProcessGridInput2>
                  {isoverlay ? (
                    ""
                  ) : (
                    <WPSProcessGridInput2
                      wps_detail={wps_detail}
                      readOnly={isReadonly}
                      disabled={isReadonly}
                      mainheading="Backing"
                      ColumnHeader="Gas Type - % comp"
                      ColumnHeader1="Flow Rate"
                      Columndimension="I/min"
                      maxLength={maxLength_WPS.WPSD_WP_BackingGasType}
                      status={
                        error.WPSD_WP_BackingGasType.status ||
                        error.WPSD_WP_BackingFlowRate.status
                      }
                      message={
                        error.WPSD_WP_BackingGasType.message ||
                        error.WPSD_WP_BackingFlowRate.message
                      }
                      type="text"
                      name="WPSD_WP_BackingGasType"
                      name1="WPSD_WP_BackingFlowRate"
                      validatorFn={isAllowDashedPercentageSpecialCharacters}
                      validatorFn1={isAllowDashedSpecialCharacters}
                      handleChange={handleDetailChange}
                      setError={setError}
                      customWidth={"275px"}
                    ></WPSProcessGridInput2>
                  )}
                  <WPSProcessGridInput2
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    mainheading="Trailing"
                    ColumnHeader="Gas Type - % comp"
                    ColumnHeader1="Flow Rate"
                    Columndimension="I/min"
                    maxLength={maxLength_WPS.WPSD_WP_ShieldingGasType}
                    status={
                      error.WPSD_WP_TrailingGasType.status ||
                      error.WPSD_WP_TrailingFlowRate.status
                    }
                    message={
                      error.WPSD_WP_TrailingGasType.message ||
                      error.WPSD_WP_TrailingFlowRate.message
                    }
                    type="text"
                    name="WPSD_WP_TrailingGasType"
                    name1="WPSD_WP_TrailingFlowRate"
                    validatorFn={isAllowDashedPercentageSpecialCharacters}
                    validatorFn1={isAllowDashedSpecialCharacters}
                    handleChange={handleDetailChange}
                    setError={setError}
                    customWidth={"275px"}
                  ></WPSProcessGridInput2>
                  <WPSProcessGridSelect
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader={
                      <span className="greenfont" style={{ fontWeight: "700" }}>
                        Arc Transfer Mode(FCAW/GMAW)
                      </span>
                    }
                    Columndimension="mm"
                    status={error.WPSD_WP_ArcTransferMode.status}
                    message={error.WPSD_WP_ArcTransferMode.message}
                    name="WPSD_WP_ArcTransferMode"
                    handleChange={handleDetailChange}
                    option
                    array={Arc_Transfer}
                  ></WPSProcessGridSelect>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="String or Weave"
                    status={error.WPSD_WP_StringOrWeave.status}
                    message={error.WPSD_WP_StringOrWeave.message}
                    type="text"
                    maxLength={maxLength_WPS.WPSD_WP_StringOrWeave}
                    name="WPSD_WP_StringOrWeave"
                    handleChange={handleDetailChange}
                    setError={setError}
                  ></WPSProcessGridInput>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Orifice / Gas Cup Size"
                    Columndimension="mm"
                    status={error.WPSD_WP_Orifice_GasCupSize.status}
                    message={error.WPSD_WP_Orifice_GasCupSize.message}
                    type="text"
                    maxLength={maxLength_WPS.WPSD_WP_Orifice_GasCupSize}
                    name="WPSD_WP_Orifice_GasCupSize"
                    setError={setError}
                    handleChange={handleDetailChange}
                    validatorFn={isAllowDashedSpecialCharacters}
                  ></WPSProcessGridInput>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="CTWD"
                    maxLength={maxLength_WPS.WPSD_WP_CTWD}
                    Columndimension="mm"
                    status={error.WPSD_WP_CTWD.status}
                    message={error.WPSD_WP_CTWD.message}
                    type="text"
                    name="WPSD_WP_CTWD"
                    setError={setError}
                    handleChange={handleDetailChange}
                    validatorFn={isAllowDashedSpecialCharacters}
                  ></WPSProcessGridInput>
                  <WPSProcessGridSelect
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Multiple / Single Pass Per Side"
                    Columndimension="mm"
                    status={error.WPSD_WP_Multiple_SinglePassPerSide.status}
                    message={error.WPSD_WP_Multiple_SinglePassPerSide.message}
                    name="WPSD_WP_Multiple_SinglePassPerSide"
                    handleChange={handleDetailChange}
                    option
                    array={Single_Pass}
                  ></WPSProcessGridSelect>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Multi or Single Layer"
                    status={error.WPSD_WP_Multiple_SingleLayer.status}
                    message={error.WPSD_WP_Multiple_SingleLayer.message}
                    type="text"
                    name="WPSD_WP_Multiple_SingleLayer"
                    maxLength={maxLength_WPS.WPSD_WP_Multiple_SingleLayer}
                    setError={setError}
                    handleChange={handleDetailChange}
                  ></WPSProcessGridInput>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Multi / Single Electrode"
                    maxLength={maxLength_WPS.WPSD_WP_Multi_SingleElectrode}
                    status={error.WPSD_WP_Multi_SingleElectrode.status}
                    message={error.WPSD_WP_Multi_SingleElectrode.message}
                    type="text"
                    name="WPSD_WP_Multi_SingleElectrode"
                    setError={setError}
                    handleChange={handleDetailChange}
                  ></WPSProcessGridInput>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Electrode Spacing Lateral"
                    maxLength={maxLength_WPS.WPSD_WP_ElectrodeSpacing_Late}
                    Columndimension="mm"
                    status={error.WPSD_WP_ElectrodeSpacing_Late.status}
                    message={error.WPSD_WP_ElectrodeSpacing_Late.message}
                    type="text"
                    name="WPSD_WP_ElectrodeSpacing_Late"
                    validatorFn={isAlphanumericWithPlusAmpersandEqualsPlusMinus}
                    handleChange={handleDetailChange}
                    setError={setError}
                  ></WPSProcessGridInput>
                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Electrode Spacing Longitudinal"
                    Columndimension="mm"
                    maxLength={maxLength_WPS.WPSD_WP_ElectrodeSpacing_Logit}
                    status={error.WPSD_WP_ElectrodeSpacing_Logit.status}
                    message={error.WPSD_WP_ElectrodeSpacing_Logit.message}
                    type="text"
                    name="WPSD_WP_ElectrodeSpacing_Logit"
                    validatorFn={isAlphanumericWithPlusAmpersandEqualsPlusMinus}
                    setError={setError}
                    handleChange={handleDetailChange}
                  ></WPSProcessGridInput>


                  <WPSProcessGridInput
                    wps_detail={wps_detail}
                    readOnly={isReadonly}
                    disabled={isReadonly}
                    ColumnHeader="Electrode Angle"
                    Columndimension="deg."
                    maxLength={maxLength_WPS.WPSD_WP_ElectrodeAngleDegree}
                    status={error.WPSD_WP_ElectrodeAngleDegree.status}
                    message={error.WPSD_WP_ElectrodeAngleDegree.message}
                    setError={setError}
                    type="text"
                    name="WPSD_WP_ElectrodeAngleDegree"
                    handleChange={handleDetailChange}
                    validatorFn={isAlphanumericWithPlusAmpersandEqualsPlusMinus}

                  ></WPSProcessGridInput>

                  {isoverlay ? (
                    <WPSProcessGridInput
                      wps_detail={wps_detail}
                      readOnly={isReadonly}
                      disabled={isReadonly}
                      ColumnHeader="Weld Bead Overlap"
                      maxLength={maxLength_WPS.WPSD_WP_Weld_Bead_Overlap}
                      Columndimension=""
                      status={error.WPSD_WP_Weld_Bead_Overlap.status}
                      message={error.WPSD_WP_Weld_Bead_Overlap.message}
                      type="text"
                      name="WPSD_WP_Weld_Bead_Overlap"
                      validatorFn={isAlphanumericWithPlusAmpersandEqualsPercentMinus}
                      setError={setError}
                      handleChange={handleDetailChange}
                    ></WPSProcessGridInput>
                  ) : (
                    <WPSProcessGridInput
                      wps_detail={wps_detail}
                      readOnly={isReadonly}
                      disabled={isReadonly}
                      ColumnHeader="Maximum Pass Thickness"
                      Columndimension="mm"
                      maxLength={maxLength_WPS.WPSD_WP_Max_Pass_Thickness}
                      status={error.WPSD_WP_Max_Pass_Thickness.status}
                      message={error.WPSD_WP_Max_Pass_Thickness.message}
                      type="text"
                      name="WPSD_WP_Max_Pass_Thickness"
                      validatorFn={isAlphanumericWithPlusAmpersandEqualsLessThanMinus}
                      setError={setError}
                      handleChange={handleDetailChange}
                    ></WPSProcessGridInput>
                  )}
                </tbody>
              </Table>
            </Col>
          </div>

        </Row>
        <Row
          className="mb-4"
          style={{ padding: "0px 30px", position: "relative", bottom: "28px" }}
        >
          <Col md={3}>
            <SingleInput
              disabled={isReadonly}
              name="WPSD_WP_MinimumPreheatTemp_DataLogger"
              type="text"
              maxLength={maxLength_WPS.WPSD_WP_MinimumPreheatTemp_DataLogger}
              status={error.WPSD_WP_MinimumPreheatTemp_DataLogger.status}
              value={headerObj.WPSD_WP_MinimumPreheatTemp_DataLogger}
              onChange={handleChangeHeader}
              label="DataLogger - Preheat Temp"
              message={error.WPSD_WP_MinimumPreheatTemp_DataLogger.message}
              error={error}
              setError={setError}
            ></SingleInput>
          </Col>
          <Col md={3}>
            <SingleInput
              disabled={isReadonly}
              name="WPSD_WP_MaximumInterpassTemp_DataLogger"
              type="text"
              maxLength={maxLength_WPS.WPSD_WP_MaximumInterpassTemp_DataLogger}
              status={error.WPSD_WP_MaximumInterpassTemp_DataLogger.status}
              value={headerObj.WPSD_WP_MaximumInterpassTemp_DataLogger}
              onChange={handleChangeHeader}
              label="DataLogger - Interpass Temp"
              message={error.WPSD_WP_MaximumInterpassTemp_DataLogger.message}
              error={error}
              setError={setError}


            ></SingleInput>
          </Col>
          <Col md={3}>

            <SingleInput
              disabled={isReadonly}
              name="WPSD_WP_Maximumtravelspeed_DataLogger"
              type="text"
              maxLength={maxLength_WPS.WPSD_WP_Maximumtravelspeed_DataLogger}
              status={error.WPSD_WP_Maximumtravelspeed_DataLogger.status}
              value={headerObj.WPSD_WP_Maximumtravelspeed_DataLogger}
              onChange={handleChangeHeader}
              label="  DataLogger - Travel Speed"
              message={error.WPSD_WP_Maximumtravelspeed_DataLogger.message}
              error={error}
              setError={setError}


            ></SingleInput>

          </Col>
        </Row>
        <RenderIf isTrue={popUp.type === "Single" && showForm}>
          <SingleValuePopUp
            show={showForm}
            onHide={() => setShowForm(false)}
            setSelected={setPopUpData}
            masterName={popUp.name}
            paramkey={popUp.key}
            paramvalue={popUp.value}
            data={ItemActive}
            backdrop="static"
            title="Welding Consumable Item Code
"
          />
        </RenderIf>
      </Row>
    );
  }
);

export default React.memo(WeldingProcedure);
